import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight, FiCheck } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Seo from "../chrome/Seo";
import Invite from "../sections/Invite";
import services, { findService } from "../lib/services";

const pad = (n) => String(n).padStart(2, "0");

const Service = () => {
  const { slug } = useParams();
  const svc = findService(slug);
  if (!svc) return <Navigate to="/services" replace />;

  const idx = services.findIndex((s) => s.slug === slug);
  const others = services.filter((s) => s.slug !== slug).slice(0, 3);

  return (
    <Frame>
      <Seo title={svc.title} description={svc.lead} />

      <section className="svc-hero">
        <div className="shell">
          <div className="crumb">
            <Link to="/">Home</Link><span className="sep">/</span>
            <Link to="/services">Services</Link><span className="sep">/</span>
            {svc.title}
          </div>
          <span className="eyebrow">Capability {pad(idx + 1)} / {pad(services.length)}</span>
          <h1>{svc.title}</h1>
          <p className="lede">{svc.lead}</p>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="svc-body">
            <div className="prose">
              {svc.body.map((p, i) => <p key={i}>{p}</p>)}
              <div style={{ marginTop: "2.25rem" }}>
                <Link to="/contact" className="btn btn--ink">
                  Discuss this capability <FiArrowRight />
                </Link>
              </div>
            </div>

            <aside>
              <div className="panel">
                <h4>What's covered</h4>
                <ul className="tick-list">
                  {svc.deliverables.map((d, i) => (
                    <li key={i}>
                      <span className="mark"><FiCheck /></span>
                      <span>{d}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>

          <div className="also">
            <div className="section-title section-title--left">
              <span className="eyebrow">Also relevant</span>
              <h2 style={{ fontSize: "1.9rem" }}>Other capabilities you may want to combine.</h2>
            </div>
            <div className="grid">
              {others.map((s) => {
                const i = services.findIndex((x) => x.slug === s.slug);
                return (
                  <Link key={s.slug} to={`/services/${s.slug}`} className="cap">
                    <div className="head">
                      <span className="num">{pad(i + 1)} / 11</span>
                    </div>
                    <h3>{s.title}</h3>
                    <p>{s.lead}</p>
                    <span className="more">Read more <FiArrowUpRight /></span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <Invite />
    </Frame>
  );
};

export default Service;
